import axios from 'axios'
import url from './url.js'

function fetch () {
  return new Promise((resolve, reject) => {
    axios({
      method: 'POST',
      url: url.category,
      dataType: 'json'
    })
      .then(response => {
        resolve(response.Categories)
      })
      .catch(() => {})
  })
}

export default {
  getCategory () {
    return fetch()
  }
}



// WEBPACK FOOTER //
// ./src/api/category.js